module.exports = __webpack_public_path__ + "img/user-menu-profile.602a7ea4.svg";